import React from 'react'
import { Base } from '../components'
import { LegalPDFViewer } from '../shared/components/legal-pdf-viewer'
import { PAGES } from '../utils'
import { getLegalUrl, LegalAgreements } from '../utils/urls'

const AccountAgreement = (): JSX.Element => {
  const ACCOUNT_AGREEMENT = PAGES.ACCOUNT_AGREEMENT
  const url = getLegalUrl(LegalAgreements.ACCOUNT_AGREEMENT)

  return (
    <Base
      headKey={ACCOUNT_AGREEMENT.HEAD_KEY}
      title={ACCOUNT_AGREEMENT.TITLE}
      metaDescription={ACCOUNT_AGREEMENT.DESCRIPTION}
      breadcrumbs={ACCOUNT_AGREEMENT.BREADCRUMBS}
    >
      <LegalPDFViewer url={url} />
    </Base>
  )
}

export default AccountAgreement
